import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { HeaderTitle } from '@/idv/components';
const ConsentText = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.consent.consent-text"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <HeaderTitle title={t1} subtitle={t2} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-body-2 text-secondary mb-4 mt-6"><Trans ns="idv" i18nKey={_temp3} components={{
        privacy: <a href="https://www.onefootprint.com/privacy-policy" rel="noopener noreferrer" target="_blank" className="underline text-[#2D2D2D]" />,
        toc: <a href="https://www.onefootprint.com/terms-of-service" rel="noopener noreferrer" target="_blank" className="underline text-[#2D2D2D]" />,
        incodePrivacy: <a href="https://incode.com/privacy-policy/" rel="noopener noreferrer" target="_blank" className="underline text-[#2D2D2D]" />
      }} /></p>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default ConsentText;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1["document-flow"]["id-doc"].pages.consent["consent-text"].description;
}